import View from "./view";
import Presenter from "./presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.management.sales-report",
    url: "/todas-as-vendas",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        name: "Todas as Vendas",
        priority: 200,
        // authorization: (context => context.user.permissions.includes('view_closed_sales')),
        state: "app.management.sales-report"
      }
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/management/sales-report/index.js